import { PublicClientApplication } from "@azure/msal-browser";
import { Client } from "@microsoft/microsoft-graph-client";
import { loginRequest, msalConfig } from "./msalConfig"; // Update path as needed
import { InteractionRequiredAuthError } from "@azure/msal-browser";

// Create an authenticated MS Graph client
const getAuthenticatedClient = (account, msalInstance) => {
  const accessToken = async () => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      try {
        const response = await msalInstance.acquireTokenSilent({
          account: accounts[0],
          scopes: loginRequest.scopes,
        });
        return response.accessToken;
      } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
          const response = await msalInstance.acquireTokenPopup({
            scopes: loginRequest.scopes,
          });
          return response.accessToken;
        } else {
          console.error(e);
        }
      }
    }
  };

  const token = accessToken();

  return Client.init({
    authProvider: (done) => {
      token
        .then((accessToken) => {
          done(null, accessToken);
        })
        .catch((err) => done(err, null));
    },
  });
};

export { getAuthenticatedClient };
